module.exports = __webpack_public_path__ + "static/praga-2-e762fbb73ccb38ea0ed15094850df9ac.jpg";